var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 334,
    viewBox: "0 0 514 334",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A51931",
    d: "M1 1h512v57H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F8",
    d: "M1 58h512v57H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2A4A",
    d: "M1 115h512v104H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F8",
    d: "M1 219h512v57H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A51931",
    d: "M1 276h512v57H1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/th.913a9cb0eb45a040eef08cc736410b00.svg";
export { ForwardRef as ReactComponent };